import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import styles from './daily-statements.styles';
import CalendarModal from '../../../components/common/calendar-modal';
import DateSelectionBar from '../../../components/common/date-selection-bar';
import format from 'date-fns/format';
import { LoadingCircle } from '../../../components/common/loading';
import SimpleDate from '../../../components/common/date';
import ReportStatement from '../report-statement';
import moment from 'moment';
import { DatePicker } from '@dbk/ui-datepicker';

var languageCode = 'en';
class DailyStatement extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      outputType: 'daily',
      value: {
        from: moment(this.props.daily.startDate),
        to: moment(this.props.daily.endDate),
      }
    };
    this.handlePress = this.handlePress.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.props.getDailyStatementData({ outputType: this.state.outputType });
    this.renderWebView = this.renderWebView.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { daily } = this.props;
    if (this.props.daily) {
      if ((daily.startDate != prevProps.daily.startDate) || (daily.endDate != prevProps.daily.endDate)) {
        this.props.getDailyStatementData({ outputType: this.state.outputType });
      }
    }
  }

  onApply = ()=> {
    this.props.onApply(this.state.value.from.format('YYYY-MM-DD'), this.state.value.to.format('YYYY-MM-DD'));
  }

  handleOnChange = (range)=> {
    this.setState({
      value: {
        ...this.state.value,
        ...range
      }
    })
  }

  renderWebView() {
    const { dailyStatementsList } = this.props.daily;
    const {
      i18n: { messages },
    } = this.props;

    if (this.props.report.busy == true) {
      return (
        <View style={styles.root}>
          <View style={styles.groupSelection}>
            <LoadingCircle />
          </View>
        </View>
      );
    }
    if (dailyStatementsList != undefined && dailyStatementsList != null && dailyStatementsList.length > 0) {
      return (
        <div className="row small-up-2 medium-up-3 large-up-4">
          <ReportStatement
            reportList={dailyStatementsList}
            pagefrom={'daily'}
          />
          {/* { dailyStatementsList.map((day, index) => {
            let iconFlag=false;
            if(index==0){
              iconFlag=true;
            }
            return (
              <div className="column column-block">
                <TouchableOpacity onPress={this.handlePress.bind(this, {day})}>
                  { iconFlag ?
                    <TouchableBlock
                    title={day.statementDates}
                      footerText={day.noOfStatements + " "+messages['app.reports.common.items']}
                      notifyIcon
                    />
                    :
                    <TouchableBlock
                      title={day.statementDates}
                      footerText={day.noOfStatements + " "+messages['app.reports.common.items']}
                    />
                  }
                </TouchableOpacity>
              </div>
            );
          })} */}
        </div>
      );
    } else {
      return (
        <div>
          <Large style={{ textAlign: 'center' }}>
            {messages['app.reports.noRecords']}
          </Large>
        </div>
      );
    }
  }

  handlePress(day) {
    let selectedDate = {
      "date": day.day.statementDates,
      "outputType": this.state.outputType,
      "selectedItems": day.day.noOfStatements
    }
    this.props.setBusy();
    setTimeout(() => {
      this.props.getDailyPdfList({ selectedDate });
    }, 100);
  }

  onSelectDate(test) {
    this.props.daily.calendar.open();
  }

  render() {
    let completeDate;
    const { i18n: { messages }, dailyStatementsList, auth } = this.props;
    const { startDate, endDate } = this.props.daily;

    if (auth.langCode && auth.langCode != null) {
      languageCode = auth.langCode.toLowerCase();
    }

    if (startDate == endDate) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.singleLanguage']} <SimpleDate value={format(startDate, 'DD MMMM YYYY')} /></div>;
    } else if (startDate != undefined && startDate.length != 0 && endDate != undefined && endDate.length != 0) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage']} <SimpleDate value={format(startDate, 'DD MMMM YYYY')} /> {messages['app.common.to']} <SimpleDate value={format(endDate, 'DD MMMM YYYY')} /></div>;
    }
    
    let show7DaysText = this.state.value.to.diff(this.state.value.from, 'days') === 6 ? true : false;

    if (this.props.daily.isDateBarClickable) {
      noSelectDate = true;
    }

    return (
      <div className="minHeight">
        <div className="row">
          <div className="columns small-12 medium-12 large-12">
            <div className="module">
              <View style={styles.root}>
                <H1 secondary>
                  {messages['app.common.pageTitle.dailyStat']}
                </H1>
                <div className="module columns small-12 medium-12 large-12">
                  <View style={styles.support}>
                    <div className="columns small-8 medium-8 large-8">
                      {show7DaysText &&
                        <Text secondary>
                          {messages['app.report.dailyStatementsHeader']}
                        </Text>
                      }
                    </div>
                    <TouchableOpacity onPress={this.onSelectDate.bind(this, 'test')}>
                      <Text secondary testID="selectDate-label">{messages['app.report.selectDate']}</Text>
                    </TouchableOpacity>
                    <div className="columns small-3 medium-3 large-3">
                      <DatePicker
                          enableYearNavigation
                          enableRangeSelection
                          onChange={this.handleOnChange}
                          value={this.state.value}
                          startDate={moment().add(-1, 'year')}
                          endDate={moment()}
                          selectionStart={this.state.value.from}
                          selectionEnd={this.state.value.to}
                          onApply={this.onApply}
                      />
                    </div>
                  </View>
                </div>
                <div className="columns small-12 medium-12 large-12 small-centered medium-centered large-centered margin-top-15">
                  <View style={styles.dateSelectionBar}>
                    <DateSelectionBar
                      text={completeDate}
                      isEditable={this.props.daily.isDateBarClickable}
                      onEditPress={() => this.props.daily.calendar.open()} />
                  </View>
                </div>
                <div className="columns margin-top-30">
                  {this.renderWebView()}
                </div>
              </View>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DailyStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  daily: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    pdf: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    setBusy: {
      $call: 'report.setBusy'
    },
    report: {
      busy: true
    },
    auth: {
      langCode: true,
    },
    daily: {
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      pdf: true,
      dateDisplay: true,
      isDateBarClickable: true,
      dailyStatementsList: true,
    },
    getDailyStatementData: {
      $call: 'daily.getDailyStatements'
    },
    getDailyPdfList:
      {
        $call: 'daily.getPdfLists'
      },
    onApply: {
      $call: 'daily.onCalendarDone'
    },
  },
})(DailyStatement);
